const cards = [
  {
    title: '暑期档必看：20 部高分华语电影盘点',
    desc: '从经典到新锐，精选华语影坛口碑佳作。涵盖动作、喜剧、悬疑、文艺等类型，窝窝影院高清播放在线不缓冲，陪你度过完美夏日。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Warm%20summer%20outdoor%20cinema%20scene%20with%20string%20lights%20and%20comfortable%20seating%20under%20twilight%20sky%2C%20cozy%20movie%20night%20atmosphere%2C%20golden%20hour%20lighting%2C%20relaxed%20entertainment%20vibe%2C%20cinematic%20photography%20style&width=800&height=500&seq=cards-summer-01&orientation=landscape',
  },
  {
    title: '全网首发！《流浪地球3》观影指南',
    desc: '深度解析续集与前作关联彩蛋，完整世界观设定科普。在窝窝影院流畅观看超清画质无广告，不错过每一个震撼细节。',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20sci-fi%20scene%20with%20giant%20planet%20and%20spaceship%20in%20deep%20space%2C%20cinematic%20lighting%20with%20blue%20and%20orange%20contrast%2C%20epic%20scale%2C%20movie%20poster%20aesthetic%2C%20professional%20film%20photography%20composition&width=800&height=500&seq=cards-scifi-02&orientation=landscape',
  },
  {
    title: '追剧党福音：本月热播剧更新日历',
    desc: '完整整理本月每日更新的热播电视剧排期，涵盖国产剧、港台剧、日韩剧。窝窝影院海量高清电影电视剧免费在线观看，每日更新不卡顿。',
    tag: '追剧日历',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20desk%20setup%20with%20calendar%20and%20warm%20ambient%20lighting%2C%20minimalist%20aesthetic%2C%20cozy%20home%20office%20vibe%2C%20soft%20golden%20tone%2C%20lifestyle%20photography%2C%20clean%20composition&width=800&height=500&seq=cards-calendar-03&orientation=landscape',
  },
  {
    title: '动画爱好者的宝藏：国产动画崛起之路',
    desc: '盘点近年国产动画口碑之作，从《哪吒》到《深海》，见证国漫技术飞跃。窝窝影院持续收录优质国产动画电影。',
    tag: '国漫专题',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20ink%20painting%20style%20landscape%20with%20mountains%20and%20mist%2C%20artistic%20traditional%20animation%20aesthetic%2C%20warm%20earthy%20tones%2C%20ethereal%20atmosphere%2C%20cinematic%20composition%2C%20elegant%20art%20style&width=800&height=500&seq=cards-anime-04&orientation=landscape',
  },
  {
    title: '经典永流传：100 部 IMDb 高分电影合集',
    desc: '精选全球影史评分最高的 100 部经典影片，《肖申克的救赎》《教父》《黑暗骑士》等悉数收录。窝窝影院高清播放，重温永恒经典。',
    tag: '经典合集',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20movie%20theater%20interior%20with%20red%20velvet%20seats%20and%20golden%20decor%2C%20classic%20Hollywood%20aesthetic%2C%20warm%20dramatic%20lighting%2C%20nostalgic%20atmosphere%2C%20elegant%20cinema%20photography%2C%20rich%20textures&width=800&height=500&seq=cards-classic-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            精选推荐
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            专题策划 · 发现好内容
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer group ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-48 md:h-56 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={card.title}
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium bg-secondary-100 text-secondary-700 mb-2 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="font-heading font-bold text-foreground-900 text-lg mb-2">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}